<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Per Kr. Heitmann is a drug hunter, police officer, and founder of a shared house for drug addicts. After travelling as a relief worker to the Middle East on a voluntary basis for 25 years, he now puts into words the story of <em>The Aramaean</em>. A true story about the drug hunter’s greatest hero.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ddc3fa9c